import type { CrossBorderReceiver, Receiver } from '../generated-types';
import { ReceiverElement, ReceiverType } from '../widgets/Receivers/ReceiverElement';

const mapReceiverToReceiverItem = (receiver: Receiver): ReceiverElement => {
    return {
        accountNumber: receiver.accountNumber,
        name: receiver.name,
        id: receiver.id.value,
        receiverType: ReceiverType.RECEIVER,
        receiver,
    };
};

const mapCrossBorderReceiverToReceiverItem = (crossBorderReceiver: CrossBorderReceiver): ReceiverElement => {
    return {
        accountNumber: { value: crossBorderReceiver.account.number },
        name: crossBorderReceiver.name,
        id: crossBorderReceiver.id.value,
        receiverType: ReceiverType.CROSS_BORDER_RECEIVER,
        crossBorderReceiver,
    };
};

const useReceiverElements = (receivers: Receiver[] = [], crossBorderReceivers: CrossBorderReceiver[] = []) => {
    const receiverElements = receivers.map(mapReceiverToReceiverItem);
    const crossBorderElements = crossBorderReceivers.map(mapCrossBorderReceiverToReceiverItem);

    return [...receiverElements, ...crossBorderElements].sort((a, b) => a.name.localeCompare(b.name));
};

export default useReceiverElements;
